import styled from 'styled-components';

import { Text } from '@chakra-ui/react';

export const Title = styled(Text)`
  font-weight: 500;
  font-size: 13px; ;
`;

export const Description = styled(Text)`
  font-weight: 500;
  font-size: 18px; ;
`;
